export class Update {
  type: 'SUCCESS' = 'SUCCESS';

  static path = '/api/careRecipient/update';

  static async extract(_response: Response): Promise<Update> {
    return new Update();
  }
}
